<!--
  DEPRECATED: This component is no longer used and will be removed in a future release.
-->
<template>
  <div class="w-full h-full p-3 overflow-auto">
    <div :id="`table-${pageReference}-${current_object_type?.type}`" class="w-full h-full pr-1 overflow-auto">
      <slot name="header" />
      <TabGroup
        :selected-index="selected_tab_index"
        class="relative transition ease-in-out rounded-lg focus:outline-none bg-light-box-background dark:bg-dark-box-background duration-side-menu-transition-duration"
        as="div"
        @change="selected_tab_index = $event">
        <TabList
          :class="[{ 'opacity-0 h-0': pageReference == 'portfolio' }]"
          class="flex items-start relative border-b-[1px] dark:border-dark-divider-border rounded-tl-md shadow-sm rounded-tr-md focus:outline-none">
          <Tab v-for="element in object_types" :key="element.type" v-slot="{ selected }" as="template">
            <div :class="[selected ? '!text-blue text-[15px] font-normal' : 'font-normal']" />
          </Tab>
        </TabList>
        <TabPanels class="shadow-lg">
          <TabPanel v-for="object_type in object_types" :key="object_type.type" v-slot="{ selected }" class="outline-none">
            <keep-alive>
              <ObjectView
                v-if="selected"
                :object-type="object_type.type"
                :page-reference="pageReference"
                @selectedOwners="$emit('update:selectedOwners', $event)"
                @currentFilter="$emit('update:currentFilter', $event)"
                @selectedRecords="$emit('update:selectedRecords', $event)"
                @selectedGroup="$emit('update:selectedGroup', $event)" />
            </keep-alive>
          </TabPanel>
        </TabPanels>
      </TabGroup>
      <slot name="footer" />
    </div>
  </div>
</template>

<script>
import ObjectView from "@/components/shared/object-view/ObjectView.vue"
import { Tab, TabGroup, TabList, TabPanel, TabPanels } from "@headlessui/vue"

import { ALL_EMITTERS } from "@/store/constants/all_emitters"

export default {
  components: {
    TabList,
    TabGroup,
    TabPanel,
    Tab,
    TabPanels,
    ObjectView
  },
  inject: ["getPageTabs"],
  props: {
    pageReference: {
      type: String,
      required: true
    }
  },
  emits: ["update:selectedObject", "update:currentFilter", "update:selectedRecords", "update:selectedGroup", "update:selectedOwners"],
  data() {
    return {
      selected_tab_index: 0,
      object_types: []
    }
  },
  computed: {
    tabs_slugs() {
      return this.object_types.map((x) => x.type)
    },

    current_object_type() {
      return this.object_types[this.selected_tab_index]
    }
  },
  watch: {
    selected_tab_index() {
      this.$emit("update:selectedObject", this.current_object_type)
      // history.replaceState(history.state, "", "?object=" + this.tabs_slugs[this.selected_tab_index])
    }
  },
  created() {
    this.register_listeners()

    this.object_types = this.getPageTabs({ page_reference: this.pageReference })
    this.setGetTab()
    this.$emit("update:selectedObject", this.current_object_type)
  },
  activated() {
    this.register_listeners()
  },
  deactivated() {
    this.unregister_listeners()
  },
  unmounted() {
    this.unregister_listeners()
  },
  methods: {
    register_listeners() {
      this.$emitter.on(ALL_EMITTERS.PORTFOLIO_UPDATED_IN_OBJECTS_VIEW, () => {
        this.object_types = this.getPageTabs({ page_reference: this.pageReference })
      })
    },
    unregister_listeners() {
      this.$emitter.off(ALL_EMITTERS.PORTFOLIO_UPDATED_IN_OBJECTS_VIEW)
    },
    setGetTab() {
      if (this.$route.query["object"]) {
        if (this.tabs_slugs.indexOf(this.$route.query["object"]) != -1) {
          this.selected_tab_index = this.tabs_slugs.indexOf(this.$route.query["object"])
        }
      } else {
        // history.replaceState(history.state, "", "?object=" + this.tabs_slugs[this.selected_tab_index])
      }
    }
  }
}
</script>
